import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Inventory Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'dUEqqa',
  },
  description: {
    description: 'Inventory Placeholder Description',
    defaultMessage: 'No Inventory data to view at the moment',
    id: '36l5+9',
  },
  boldStatusView: {
    description: 'Inventory Placeholder Bold Status View Name',
    defaultMessage: 'Inventory',
    id: 'RjtUG0',
  },
});

const InventoryGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default InventoryGridPlaceholder;
